<template>
    <div>
        <div class="d-flex align-items-center justify-content-between mb-2">
            <label class="font-weight-bold mb-0">버전 타임라인</label>
            <b-button size="sm" variant="outline-primary" @click="addNewVersion" :disabled="adding">
                <b-spinner v-if="adding" small class="mr-1" />
                새 버전 추가
            </b-button>
        </div>
        <div v-if="loading" class="text-center py-3">
            <b-spinner variant="primary" />
        </div>
        <div v-else-if="versions.length === 0" class="text-muted text-center py-3">
            <small>버전이 없습니다.</small>
        </div>
        <div v-else class="version-list">
            <div
                v-for="v in versions"
                :key="v.id || v.version"
                :class="['version-item', 'p-2', 'mb-1', 'border', 'rounded', { 'border-primary bg-light': currentVersion === v.version }]"
                style="cursor: pointer;"
                @click="$emit('version-selected', v)"
            >
                <div class="d-flex align-items-center justify-content-between">
                    <span class="font-weight-bold">v{{ v.version }}</span>
                    <b-badge :variant="v.is_active ? 'success' : 'secondary'">
                        {{ v.is_active ? '활성' : '비활성' }}
                    </b-badge>
                </div>
                <div class="text-muted small mt-1">{{ v.label }}</div>
                <div class="text-muted" style="font-size: 0.75rem;">{{ formatDate(v.created_at) }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
    name: 'SnippetVersionTimeline',
    props: {
        snippetCode: {
            type: String,
            default: ''
        },
        currentVersion: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            versions: [],
            loading: false,
            adding: false,
        };
    },
    watch: {
        snippetCode: {
            immediate: true,
            handler(val) {
                if (val) this.fetchVersions();
            }
        }
    },
    methods: {
        async fetchVersions() {
            if (!this.snippetCode) return;
            this.loading = true;
            try {
                const resp = await this.$axios.get('/mail/snippet', { params: { keyword: this.snippetCode, size: 100 } });
                const items = resp.data.results || resp.data.items || resp.data;
                this.versions = items
                    .filter(v => v.code === this.snippetCode)
                    .sort((a, b) => b.version - a.version);
            } catch (e) {
                console.error('버전 목록 로드 실패', e);
            } finally {
                this.loading = false;
            }
        },
        async addNewVersion() {
            if (!this.versions.length) return;
            const latest = this.versions[0];
            const maxVersion = latest.version;
            this.adding = true;
            try {
                let latestContent = latest.content || '';
                if (!latestContent) {
                    const detail = await this.$axios.get(`/mail/snippet/${this.snippetCode}/${maxVersion}`);
                    latestContent = detail.data.content || '';
                }
                await this.$axios.post('/mail/snippet', {
                    code: this.snippetCode,
                    version: maxVersion + 1,
                    label: `v${maxVersion + 1}`,
                    content: latestContent,
                });
                await this.fetchVersions();
                this.$bvToast.toast(`v${maxVersion + 1} 버전이 추가되었습니다.`, { variant: 'success', title: '성공' });
            } catch (e) {
                this.$bvToast.toast('버전 추가에 실패했습니다.', { variant: 'danger', title: '오류' });
            } finally {
                this.adding = false;
            }
        },
        formatDate(date) {
            if (!date) return '';
            return dayjs(date).format('YYYY-MM-DD HH:mm');
        }
    }
};
</script>

<style scoped>
.version-item:hover {
    background-color: #f8f9fa;
}
</style>
